import { createFileRoute } from '@tanstack/react-router'

import { Settings } from '~/boundedContext/settings/pages/settings'

export const Route = createFileRoute('/_main-layout/settings/')({
  component: Settings,
})
